import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {useAppSelector} from "../../store/hooks";
import {ViewType} from "../../view_type/ViewType";
import {SemanticSearchBetaBadge} from "./SemanticSearchBetaBadge";
import {SemanticSearchClientIcon} from "./SemanticSearchClientIcon";
import {SemanticSearchOffersCountText} from "./SemanticSearchOffersCountText";

export const SemanticSearchHeader = () => {
    const isOfferListView = useAppSelector((state) => state.viewType.current === ViewType.OFFER_LIST);

    return (
        <div className={semanticSearchQueryWrapper}>
            <div className={semanticSearchQueryContent}>
                <SemanticSearchClientIcon />

                <div className={betaBadgeWrapper}>
                    <SemanticSearchBetaBadge />
                </div>

                {isOfferListView ? (
                    <SemanticSearchOffersCountText align="center" />
                ) : (
                    <Text variant="headline_2" as="p" align="center" className={semanticSearchQueryTitle} mb={1}>
                        Skorzystaj z naszego doradcy AI
                    </Text>
                )}

                <Text variant="body_copy_0" align="center" mb={2}>
                    Powiedz nam więcej o swoich poszukiwaniach, a dopasujemy dla Ciebie najlepsze propozycje
                </Text>
            </div>
        </div>
    );
};

const semanticSearchQueryTitle = css({
    textAlign: "center"
});

const betaBadgeWrapper = css({
    display: "flex",
    justifyContent: "center",
    mb: 2
});

const semanticSearchQueryWrapper = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    p: 1.5,
    transition: "all 0.3s ease-in-out",
    bottom: 0
});

const semanticSearchQueryContent = css({
    width: "100%",
    maxWidth: "680px"
});
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {useAppSelector} from "../../store/hooks";
import {ViewType} from "../../view_type/ViewType";
import {SemanticSearchBetaBadge} from "./SemanticSearchBetaBadge";
import {SemanticSearchClientIcon} from "./SemanticSearchClientIcon";
import {SemanticSearchOffersCountText} from "./SemanticSearchOffersCountText";

export const SemanticSearchHeader = () => {
    const isOfferListView = useAppSelector((state) => state.viewType.current === ViewType.OFFER_LIST);

    return (
        <div className={semanticSearchQueryWrapper}>
            <div className={semanticSearchQueryContent}>
                <SemanticSearchClientIcon />

                <div className={betaBadgeWrapper}>
                    <SemanticSearchBetaBadge />
                </div>

                {isOfferListView ? (
                    <SemanticSearchOffersCountText align="center" />
                ) : (
                    <Text variant="headline_2" as="p" align="center" className={semanticSearchQueryTitle} mb={1}>
                        Skorzystaj z naszego doradcy AI
                    </Text>
                )}

                <Text variant="body_copy_0" align="center" mb={2}>
                    Powiedz nam więcej o swoich poszukiwaniach, a dopasujemy dla Ciebie najlepsze propozycje
                </Text>
            </div>
        </div>
    );
};

const semanticSearchQueryTitle = css({
    textAlign: "center"
});

const betaBadgeWrapper = css({
    display: "flex",
    justifyContent: "center",
    mb: 2
});

const semanticSearchQueryWrapper = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    p: 1.5,
    transition: "all 0.3s ease-in-out",
    bottom: 0
});

const semanticSearchQueryContent = css({
    width: "100%",
    maxWidth: "680px"
});
